import type {
  PublicSegment,
  PublicSegmentV4
} from "@busbud/core-types/dist/lib/poll-service/api";

export function getSegmentById(
  segment_id: string,
  segments: (PublicSegment | PublicSegmentV4)[]
): PublicSegment | PublicSegmentV4 {
  const segment = segments.find(({ id }) => segment_id === id);
  if (!segment) {
    throw new Error(`No Segment was found with the given id: ${segment_id}`);
  }
  return segment;
}
